import  Axios  from 'axios'
import { getToken } from '../Features/FeatureGlobal';


export const Post = () => {
    const AxiosPost = async( endpoint, body, aut) => {
        let res = await Axios({
             method: 'POST',
             url: endpoint,
             headers: { 
               "Content-Type": "application/json",
               Authorization: aut ? `Bearer ${getToken()}` : '',
              },
             data: JSON.stringify(body)
           }).then((succ)=>{
             return succ.data
           }).catch((err)=>{
             return err.response
           })
         return res
     }
   return {
    AxiosPost
   }
}


export const NoBodyPost = () => {
  const AxiosNoBodyPost = async(endpoint) => {
      let res = await Axios({
           method: 'POST',
           url: endpoint,
           headers: { 
             "Content-Type": "application/json",
             Authorization: `Bearer ${getToken()}`,
            },
         }).then((succ)=>{
           return succ.data
         }).catch((err)=>{
           return err.response
         })
       return res
   }
 return {
  AxiosNoBodyPost,
 }
}

export const PostToken = () => {
  const AxiosPostToken = async( endpoint, body, aut) => {
      let res = await Axios({
           method: 'POST',
           url: endpoint,
           headers: { 
             "Content-Type": "application/json",
             Authorization: aut ? `Bearer ${aut}` : '',
            },
           data: JSON.stringify(body)
         }).then((succ)=>{
           return succ.data
         }).catch((err)=>{
           return err.response
         })
       return res
   }
 return {
  AxiosPostToken
 }
}